var Axis = require('./base');

Axis.Base = Axis;
Axis.Circle = require('./circle');
Axis.Grid = require('./grid');
Axis.Helix = require('./helix');
Axis.Line = require('./line');
Axis.Polyline = require('./polyline');
module.exports = Axis;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_component@0.3.8@@antv/component/lib/axis/index.js
// module id = 316
// module chunks = 0 1 2